export const InvoicingOptionsEnum = {
  DefaultInvoiceAtClientCost: 0,
  InvoiceAtOurCost: 1,
  DoNotInvoice: 2
}
